import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-736002d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = ["onClick", "aria-label"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "car-no-wrapper" }
const _hoisted_5 = { class: "car-no" }
const _hoisted_6 = {
  key: 0,
  class: "car-no last-four-char"
}
const _hoisted_7 = { class: "count" }
const _hoisted_8 = {
  key: 1,
  class: "img-checkmark"
}
const _hoisted_9 = { class: "divider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "modal-backdrop",
        onClick: $setup.hideModal
      }),
      _createVNode(_Transition, {
        appear: "",
        name: "slide-up"
      }, {
        default: _withCtx(() => [
          ($setup.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeBusLocations, (bus, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "select-row",
                    key: index,
                    onClick: ($event: any) => ($setup.onItemSelected(bus.allocUid)),
                    "aria-label": `차량 선택: ${bus.plateNumber}`
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.sliceCarNo(bus.plateNumber)[0]), 1 /* TEXT */),
                        ($setup.sliceCarNo(bus.plateNumber)[1])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.sliceCarNo(bus.plateNumber)[1]), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("span", _hoisted_7, _toDisplayString($setup.displayLastSeatCount(index)), 1 /* TEXT */)
                    ]),
                    ($props.selectedBus?.allocUid === bus.allocUid)
                      ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                          key: 0,
                          class: "img-checkmark",
                          src: require('@/assets/icons/check.svg'),
                          alt: "선택됨",
                          "aria-hidden": "true"
                        }, null, 8 /* PROPS */, ["src"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8)),
                    _withDirectives(_createElementVNode("div", _hoisted_9, null, 512 /* NEED_PATCH */), [
                      [_vShow, index !== $setup.activeBusLocations.length - 1]
                    ])
                  ], 8 /* PROPS */, _hoisted_2))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}